import { generateShortUuid } from "@moment/api-collab/id";

/**
 * Unique client ID for this ProseMirror instance.
 * Used for collab plugin and presence tracking.
 * Generated once per session.
 */
export const prosemirrorClientId = generateShortUuid();
